/**
 * Bounded Context: Context — composable
 *
 * Usa `storeToRefs` para que refs permaneçam reativos quando consumidos
 * em templates (sem capturar valor stale).
 */

import { storeToRefs } from "pinia";
import { useContextStore } from "../store";
import type { CuriosityGap, Goal } from "../types";

export function useContext() {
  const store = useContextStore();
  const refs = storeToRefs(store);
  return {
    /** Refs reativas (auto-unwrapped no template). */
    activeGoal: refs.activeGoal,
    curiosityGaps: refs.curiosityGaps,
    maxGaps: store.maxGaps,
    /** Actions (não mutar refs diretamente). */
    setGoal: (goal: Goal | null): void => store.setGoal(goal),
    addCuriosityGap: (gap: CuriosityGap): boolean => store.addCuriosityGap(gap),
    clearCuriosityGaps: (): void => store.clearCuriosityGaps(),
  };
}
